var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-tabs",
        { attrs: { value: "common" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Common", name: "common" } },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "element-loading-spinner": "el-icon-loading",
                    "label-width": "170px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Brand", prop: "brand_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.form.brand_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "brand_id", $$v)
                            },
                            expression: "form.brand_id",
                          },
                        },
                        _vm._l(_vm.brandOptions, function ({ value, label }) {
                          return _c("el-option", {
                            key: value,
                            attrs: { value: value, label: label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Representative",
                        prop: "representative_id",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.form.representative_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "representative_id", $$v)
                            },
                            expression: "form.representative_id",
                          },
                        },
                        _vm._l(
                          _vm.representativeOptions,
                          function ({ value, label }) {
                            return _c("el-option", {
                              key: value,
                              attrs: { value: value, label: label },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Provider", prop: "provider_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.form.provider_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "provider_id", $$v)
                            },
                            expression: "form.provider_id",
                          },
                        },
                        _vm._l(
                          _vm.providerOptions,
                          function ({ value, label }) {
                            return _c("el-option", {
                              key: value,
                              attrs: { value: value, label: label },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Title", prop: "title" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Address", prop: "address" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "address", $$v)
                          },
                          expression: "form.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Signature", prop: "signature" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.signature,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "signature", $$v)
                          },
                          expression: "form.signature",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-purple px-4",
                  on: { click: _vm.store },
                },
                [_vm._v("Store")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }